import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import useAuth from "../../hooks/useAuth";
import Pagination from "../../components/Table/pagination";
import { ReactComponent as Edit } from "../../assets/images/svg/Edit.svg";
import { ReactComponent as Delete } from "../../assets/images/svg/Delete.svg";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const CampaignInvalidDataReport = () => {
    console.log("CampaignInvalidDataReport")
    const { auth } = useAuth()

    var sortFilter = useRef("");

    const Initial_pagination = {
        next: "",
        previous: "",
        count: "",
        total_pages: "",
        current_page: 1,
        page_size: 5,
        current_page_count: 0 
    };

    const navigate = useNavigate(null);

    const [InvalidList, setInvalidList] = useState([])
    const [pagination, setPagination] = useState(Initial_pagination)

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedInvalid, setSelectedInvalid] = useState(null);
    const [InvalidName, setInvalidName] = useState("");
    const [InvalidPhoneNumber, setInvalidPhoneNumber] = useState("");
    const [status, setStatus] = useState("");
    const [campaign, setCampaign] = useState("")
    const [camplist, setCampList] = useState([]);
    const [searchText, setSearchText] = useState("");

    const BASE_URL = process.env.REACT_APP_API_URL;


    const editInvalid = (Invalid) => {
        setSelectedInvalid(Invalid);
        setInvalidName(Invalid.Invalid_name);
        setInvalidPhoneNumber(Invalid.Invalid_phone_number);
        setIsModalOpen(true);
    };

    const PaginationControl = (type, number) => {
        if (type == "page") {
            if (number <= pagination.total_pages) {
                fetchCampainInvalids(number);
            } else {
                fetchCampainInvalids(1);
            }
        } else if (type == "last") {
            fetchCampainInvalids(pagination.total_pages);
        } else if (type == "prev") {
            if (pagination.current_page > 1) {
                fetchCampainInvalids(pagination.current_page - 1);
            }
        } else if (type == "next") {
            if (pagination.current_page < pagination.total_pages) {
                fetchCampainInvalids(pagination.current_page + 1);
            }
        } else {
            fetchCampainInvalids(1);
        }
    };

    const fetchCampainInvalids = async (pagenumber) => {
        let postData = {
            user_id: auth?.user_details?.id,
            page: pagenumber,
            campaign: campaign || "",
            search_text: searchText || "",
            upload_status: status || "",
            sortby:sortFilter.current.value
        };

        let config = {
            headers: { "Content-Type": "application/json" },
        };

        await axios
            .get(
                process.env.REACT_APP_API_URL + "/contactcentre/campaign_invalid_data_report/",
                {
                    params: {
                    user_id: auth?.user_details?.id,
                    page: pagenumber,
                    campaign: campaign || "",
                    search_text: searchText || "",
                    upload_status: status || "",
                    sortby:sortFilter.current.value
                    }
                }
            )
            .then((res) => {
                console.log(JSON.stringify(res.data))
                setInvalidList(res.data.results);
                setPagination((prevState) => {
                    return {
                        ...prevState,
                        total_pages: res.data?.total_pages || 0,
                        previous: res.data?.previous || null,
                        next: res.data?.next || null,
                        current_page: res.data?.current_page || 0,
                        count: res.data?.count || 0,
                        page_size: res.data?.page_size || 5,
                        current_page_count: res.data?.results?.length || 0 
                    };
                });
            });
    };

    const InvalidDelete = async (Invalid_ids) => {
        Swal.fire({
            title: "Are you sure to Delete ?",
            text: "This Invalid will be deleted from your campaign",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Delete",
        }).then(async (result) => {
            if (result.isConfirmed) {
                let config = {
                    headers: { "Content-Type": "application/json" },
                    data: {
                        "Invalid_id": Invalid_ids,
                        "camp_id": campaign
                    }
                };
                await axios
                    .delete(
                        process.env.REACT_APP_API_URL + "/contactcentre/campaign-Invalids/",
                        config
                    )
                    .then((res) => {
                        Swal.fire(
                            'Deleted!',
                            'Invalid has been deleted.',
                            'success'
                        );
                        fetchCampainInvalids(pagination.current_page)
                    })
                
                setSelectAll(false);

            }
        })
    }

    const saveInvalid = async () => {
        let updatedInvalid = {
            Invalid_name: InvalidName,
            Invalid_phone_number: InvalidPhoneNumber,
            Invalid_id: selectedInvalid.id
        };

        let config = {
            headers: { "Content-Type": "application/json" },
        };

        await axios
            .post(
                process.env.REACT_APP_API_URL + "/contactcentre/campaign-Invalids/",
                updatedInvalid,
                config
            )
            .then(() => {
                Swal.fire(
                    "Updated!",
                    "Invalid details have been updated.",
                    "success"
                );
                fetchCampainInvalids(pagination.current_page);
                setIsModalOpen(false);
            });
    };

    const fetchCampaignList = async () => {
        let post_data = {
            user_id: auth.user_details?.user,
            user_type: auth.user_details?.type,
        }

        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL + "/contactcentre/allcampaigns/",
                {
                    params: post_data,
                }
            );
            setCampList(response.data);
        } catch (err) {
            console.error(err);
        }
    }


    const SearchInvalid = () => {
        fetchCampainInvalids(1);
    };

    useEffect(() => {
        fetchCampainInvalids(1);
        fetchCampaignList();
    }, []);

    const [selectAll, setSelectAll] = useState(false);
    const [selected, setSelected] = useState([])

    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);
        const updated = InvalidList.map((item) => ({
            ...item,
            selected: checked,
        }));
        const selected_Invalid_ids = checked? updated.map(item => item.id): [];
        setSelected(selected_Invalid_ids)
        setInvalidList(updated);
    };

    const handleSelectRow = (id) => {
        setSelected(prev =>
            prev.includes(id)
                ? prev.filter(item => item !== id)
                : [...prev, id]
        );
        const updated = InvalidList.map((item) =>
            item.id === id ? { ...item, selected: !item.selected } : item
        );
        setInvalidList(updated);
    };


    const handleDeleteSelected = () => {
        console.log("Selected  ----> ", selected)
        const selectedIds = InvalidList.filter(item => selected.includes(item.id))
        if (selectedIds.length === 0 && !campaign?.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Warning!',
                text: 'Please select at least one item to delete.'
            });
            return
        } else {
            console.log("Delete all selectde items ")
            InvalidDelete(selected)
            setInvalidList(selectedIds)
        }
        // if (!window.confirm(`Delete ${selectedIds.length} items?`)) return;
    };

    const formatNumber = (num)=>{
        return Number(num).toLocaleString("en-US");
    }

    const downloadInvalidExcel= async(file_url)=>{
          
        if(! file_url){
            console.log("download failed")
            return;
        } 
        
        try{
            const response = await axios.get(BASE_URL + file_url, {
                responseType: "blob"
            });
        
            // Create a blob link for download
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
        
            const link = document.createElement("a");
            link.href = url;
            link.download =  "invalid_report.xlsx";
            document.body.appendChild(link);
            link.click();
            link.remove();
        
            Swal.fire({
                title: "Download Started",
                text: "Sample Excel sheet is being downloaded.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false
            });
        
            console.log("download success")
        }catch (error) {
            console.error("Download error:", error);

            Swal.fire({
                title: "Download Failed",
                text: "Unable to download the file.",
                icon: "error"
            });
        }
    }
      

    function formatDateTime(dateStr) {
        const date = new Date(dateStr);
        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        });
    }

    const handleInfo = (Invalid)=>{
    
        const formatNumber =(number)=>{
          return Number(number).toLocaleString("en-US");
        }
    
        Swal.fire({
          title: "Campaign Upload Summary",
          html:`<div style="width:90%; margin: 0 auto; color: black;">

                <div class="flex items-center my-4">
                    <div class="flex-grow border-t border-gray-300"></div>
                        <span class="mx-3 text-sm font-semibold text-gray-700">
                            Campaign Details
                        </span>
                    <div class="flex-grow border-t border-gray-300"></div>
                </div>
             
                <table class="border-collapse" style="width:100%;">
                    <tbody>
                    <tr>
                        <td style="padding:6px 0; text-align:left;">
                        Campaign Name
                        </td>
                        <td style="padding:6px 0;text-align:right;">
                        ${Invalid.campaign_name}
                        </td>
                    </tr>
                </table>

                <table class="border-collapse" style="width:100%;">
                    <tbody>
                    <tr>
                        <td style="padding:6px 0;  text-align:left;">
                        Total entries
                        </td>
                        <td style="padding:6px 0; text-align:right;">
                        ${formatNumber(Invalid.total_record_count)}
                        </td>
                    </tr>

                    <tr>
                        <td style="padding:6px 0;  text-align:left; color:#16a34a;">
                        Valid entries
                        </td>
                        <td style="padding:6px 0;text-align:right; color:#16a34a;">
                        ${formatNumber(Invalid.valid_record_count)}
                        </td>
                    </tr>

                    <tr>
                        <td style="padding:6px 0;  text-align:left; color:#dc2626;">
                        Invalid entries
                        </td>
                        <td style="padding:6px 0; text-align:right; color:#dc2626;">
                        ${formatNumber(Invalid.failed_record_count)}
                        </td>
                    </tr>
                    </tbody>
                </table>
                
                <div class="flex items-center my-4">
                    <div class="flex-grow border-t border-gray-300"></div>
                        <span class="mx-3 text-sm font-semibold text-gray-700">
                            Error Details
                        </span>
                    <div class="flex-grow border-t border-gray-300"></div>
                </div>

                <table class="border-collapse" style="width:100%;">
                    <tbody>
                    <tr>
                        <td style="padding:4px 0;text-align:left">Number not Provided</td>
                        <td style="padding:4px 0; text-align:right;">${Invalid.error_summary["number_not_provided"]}</td>
                    </tr>
                    <tr>
                        <td style="padding:4px 0;text-align:left">SlNumber not Provided</td>
                        <td style="padding:4px 0; text-align:right;">${Invalid.error_summary["srl_num_not_provided"]}</td>
                    </tr>
                    <tr>
                        <td style="padding:4px 0;text-align:left">Customer Name not Povided</td>
                        <td style="padding:4px 0; text-align:right;">${Invalid.error_summary["cust_name_not_provided"]}</td>
                    </tr>
                    <tr>
                        <td style="padding:4px 0;text-align:left">Agent not Exist</td>
                        <td style="padding:4px 0; text-align:right;">${Invalid.error_summary["agent_not_exist"]}</td>
                    </tr>
                    <tr>
                        <td style="padding:4px 0;text-align:left">Invalid Phone Number</td>
                        <td style="padding:4px 0; text-align:right;">${Invalid.error_summary["invalid_mob_num"]}</td>
                    </tr>
                    <tr>
                        <td style="padding:4px 0;text-align:left">Customer Already Exist</td>
                        <td style="padding:4px 0; text-align:right;">${Invalid.error_summary["customer_already_exist"]}</td>
                    </tr>
                    <tr>
                        <td style="padding:4px 0;text-align:left">Number Already Exist</td>
                        <td style="padding:4px 0; text-align:right;">${Invalid.error_summary["number_already_exist"]}</td>
                    </tr>
                    </tbody>
                </table>

                </br>

               <hr className="border-gray-500">

               </br>
               
               <p style="font-weight:600;"className="py-4">
               Status : ⚠️ <span>Uploaded with Errors</span>
               </p>
               
               </br>
               
               <hr className="border-gray-500 my-5">

                </div>
                `,
          showCancelButton: true,
          cancelButtonColor: "#d33",
          confirmButtonText: "EDIT THE CAMPAIGN",
        }).then((result)=>{
          if(result.isConfirmed){
            navigate(`/admin/campaign/create/${Invalid.campaign_id}`)
          }
        });
      }

    return (
        <>
            <h1 className="font-bold text-lg px-3 pt-3">Invalid Data Report</h1>
            <div className="flex justify-between p-3 gap-4">
                <div className="flex justify-items-start gap-6">
                    <div className="">
                        <label htmlFor="table-search" className="sr-only">
                            Search
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg
                                    className="w-5 h-5 text-gray-500 "
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                        clipRule="evenodd"
                                    ></path>
                                </svg>
                            </div>
                            <input
                                type="text"
                                id="table-search"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-60 pl-10 p-2.5  "
                                placeholder="Search for items"
                                onChange={(e) => {
                                    setSearchText(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div className="relative w-full flex space-x-2">
                        <select
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-60 pl-5 p-2.5  "
                            onChange={(e) => {
                                setCampaign(e.target.value);
                            }}
                        >
                            <option value="">Select Campaign</option>
                            {camplist &&
                                camplist.map &&
                                camplist.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                        </select>
                    </div>

                    <div className="relative w-full flex space-x-2">
                        <select
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-60 pl-5 p-2.5  "
                            onChange={(e) => {
                                setStatus(e.target.value);
                            }}
                        >
                            <option value="">Select Upload Status</option>
                            <option value={"success"}>Success</option>
                            <option value={"partial"}>Partial</option>
                            <option value={"failed"}>Failed</option>
                        </select>
                    </div>

                    <div className="">

                        <select
                            className="w-60  bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block pl-5 p-2.5  mt-0 mr-6 "
                            ref={sortFilter}
                        > 
                            <option value="">Select Sort Option</option>
                            <option value={"by_name"} selected>By Name</option>
                            <option value={"by_upload"}>By Upload Time</option>
                        </select>
                    
                  </div>


                    <div className="space-x-2">
                        <button
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                            onClick={SearchInvalid}
                        >
                            Submit
                        </button>
                    </div>

                </div>
            </div>
            <div className="overflow-x-auto p-4 relative shadow-md sm:rounded-lg h-[71.9vh]">
                <table className="w-full text-sm text-left text-gray-800 ">
                    <thead className="text-xs text-center text-gray-700 uppercase bg-gray-50 d">
                        <tr>
                            <th scope="col" className="py-3 px-6">
                                Sl-No
                            </th>
                            <th scope="col" className="py-3 px-6">
                                Campaign
                            </th>
                            <th scope="col" className="py-3 px-6">
                                Uploaded On
                            </th>
                            <th scope="col" className="py-3 px-6">
                                Total
                            </th>
                            <th scope="col" className="py-3 px-6">
                                Valid
                            </th>
                            <th scope="col" className="py-3 px-6">
                                Invalid
                            </th>
                            <th scope="col" className="py-3 px-6">
                                Upload Status
                            </th>
                            <th scope="col" className="py-3 px-6">
                                Summary
                            </th>
                            <th scope="col" className="py-3 px-6">
                                Invalid Report
                            </th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {InvalidList.map((Invalid, index) => (
                            <tr key={Invalid.id} className="bg-white border-b hover:bg-gray-50 ">
                                <td className="py-4 px-6">
                                    {index +
                                        1 +
                                        (pagination?.current_page - 1) * pagination?.page_size}
                                </td>
                                <td className="py-4 px-6">{Invalid.campaign_name}</td>
                                <td className="py-4 px-6">{formatDateTime(Invalid.uploaded_at)}</td>
                                <td className="py-4 px-6 font-semibold">{formatNumber(Invalid.total_record_count)}</td>
                                <td className="py-4 px-6 font-semibold">{formatNumber(Invalid.valid_record_count)}</td>
                                <td className="py-4 px-6 font-semibold text-red-600">{formatNumber(Invalid.failed_record_count)}</td>
                                <td className={`py-4 px-6 font-bold`}>
                                    <span className={` px-5 py-1 rounded  ${Invalid.upload_status ==="success"? "text-green-500" : Invalid.upload_status==="failed"? "text-red-500 pe-6 ps-6" : "text-orange-500" }`}>{Invalid.upload_status}</span>
                                </td>
                                <td className={`py-4 px-6 font-bold`}>
                                    {Invalid?.upload_status !== "success" && Invalid?.failed_record_count !== "0"  ? (
                                        <span>
                                            <div className="relative group inline-block">
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#FFA500"
                                                className="
                                                    w-6 h-6 p-0.5 
                                                    hover:fill-orange-400 hover:stroke-white hover:p-0 p-0.5 active:fill-none active:stroke-orange-500 active:p-0 p-0.5
                                                    transition-colors duration-100 mt-1.5  
                                                "
                                                onClick={()=>handleInfo(Invalid)}
                                                > 
                                            <circle cx="12" cy="12" r="9" strokeWidth="1.8" />
                                            <path 
                                                d="M12 8.5h.01 M12 11v4" 
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            </svg>

                                            <span className="absolute left-1/2 -translate-x-1/2 mt-2 whitespace-nowrap 
                                                            bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 
                                                            group-hover:opacity-100 transition pointer-events-none">
                                                                {Invalid?.upload_status!=="success"? 
                                                                    "Invalid Data in campaign" 
                                                                :
                                                                    "Nothing to show"
                                                                }
                                            </span>
                                            </div>
                                        </span>
                                        ):<span className="text-red font-bold text-gray-500">-NO SUMMARY-</span>}
                                
                                </td>
                                <td className="py-4 px-6">
                                    {Invalid.upload_status !=="success"? (

                                    <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={()=>downloadInvalidExcel(Invalid.file)}>
                                        <div className="flex">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-5 w-5 text-white-600 hover:text-blue-800 cursor-pointer"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                                            />
                                        </svg>
                                        <span>
                                            download excel
                                        </span>

                                        </div>
                                    </button>
                                    )
                                    :
                                    <span className="text-red font-bold text-gray-500">-NO INVALID-</span>}
                                </td>
                                
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {isModalOpen && (
                <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
                    <div className="bg-white p-6 rounded-md shadow-lg w-1/3">
                        <h2 className="text-xl font-bold mb-4">Edit Invalid</h2>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700">Name</label>
                            <input
                                type="text"
                                className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
                                value={InvalidName}
                                onChange={(e) => setInvalidName(e.target.value)}
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700">Phone Number</label>
                            <input
                                type="text"
                                className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
                                value={InvalidPhoneNumber}
                                onChange={(e) => setInvalidPhoneNumber(e.target.value)}
                            />
                        </div>
                        <div className="flex justify-end">
                            <button className="bg-red-500 text-white px-4 py-2 rounded mr-2" onClick={() => setIsModalOpen(false)}>Cancel</button>
                            <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={saveInvalid}>Save</button>
                        </div>
                    </div>
                </div>
            )}

            <div className="p-8">
                <Pagination
                    pagination_data={pagination}
                    PaginationControl={PaginationControl}
                />
            </div>
        </>
    );

}

export default CampaignInvalidDataReport;